import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import GridHeaderRow from '@/components/browse/GridHeaderRow';
import GridModelRow from '@/components/browse/GridModelRow';
import {
  Card,
  DataError,
  LoadingSkeleton,
  Typography
} from '@destination/components';

import useModels from '@/api/use-models';

export default function Browse() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const { t } = useTranslation(undefined, { keyPrefix: 'browse' });

  const { models, isLoading, isError } = useModels(searchParams);

  const handleRefresh = () => {
    navigate(0);
  };

  const isSearch = searchParams.toString().length > 0;
  const noModelsMessage = isSearch
    ? t('no_search_results')
    : t('no_configured');

  return (
    <>
      <Typography variant="pageTitle">{t('page_title')}</Typography>
      <Card className="mt-4 min-w-[816px]">
        <div className="grid grid-cols-[1.75fr,1.75fr,1.75fr,0.75fr,1fr,0.5fr,0.5fr] gap-1">
          {!isError && <GridHeaderRow />}
          {isError && (
            <div style={{ gridColumn: '1 / -1' }}>
              <DataError variant="primary" onRefresh={handleRefresh} />
            </div>
          )}
          {isLoading &&
            Array.from({ length: 3 }).map((_, idx) => (
              <div key={`loading-line-${idx}`} style={{ gridColumn: '1 / -1' }}>
                <LoadingSkeleton className="min-h-[34px] my-1" height={16} />
              </div>
            ))}

          {models?.length === 0 ? (
            <div style={{ gridColumn: '1 / -1' }}>
              <Typography variant="smallTitle" className="py-4 text-center">
                {noModelsMessage}
              </Typography>
            </div>
          ) : (
            models?.map(model => (
              <GridModelRow
                showOlderVersionsOption={
                  !searchParams ||
                  searchParams.get('includeOlderVersions') !== 'true'
                }
                key={`row-${model.aggregateId}`}
                model={model}
                defaultOpen={models.length == 1}
              />
            ))
          )}
        </div>
      </Card>
    </>
  );
}
